import moment from 'moment';
import { message, Modal } from "antd";
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from "react";
import FeatherIcon from 'feather-icons-react';
import { CheckCircleOutlined } from '@ant-design/icons';
import ArrowPipeline from "./ArrowPipelineforDeal";
import { convertCurrency, ExchangeCurrency } from '../../Filters/FilterConditions';
import { setExPoCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchDealDetails, DealUpdate } from '../../../../Api/Services/DealApiService';
import { LostIcon, OnHlodIcon } from '../../../../components/Icons/Icons';
import DefaultPopup from '../../Popup/DefaultMessagePopup'
import DealcreatePopup from '../../Popup/DealCreatePopup'

const DealStageDemo = ({ UrlId, leadStatusData, displayData, setTrigger, getDetailsData, currencySettings, setNaCTrigger, UpdatePs, canUpdateDelete, ApprovalMessage, AutomationMessage, setErrorData, setIsModalVisible1 }) => {
    const localData = useSelector((state) => state.localRedux);
    const dispatch = useDispatch();
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const stages = leadStatusData.slice(0, 6);
    const extraStages = leadStatusData.slice(6);
    const [current, setCurrent] = useState();
    const [oldPipeline, setOldPipeline] = useState()
    const [OldFixed, setOldFixed] = useState()
    const [disabled, setDisabled] = useState(false);
    const [makeEdit, setMakeEdit] = useState(false);
    const [winProbability, setWinProbability] = useState()
    const [pipeLineField, setPipeLineField] = useState()
    const [messagePopup, setMessagePopup] = useState(false)
    const [dealInitial, setDealInitial] = useState()
    const [dealInitial2, setDealInitial2] = useState()
    const [roleData, setRoleData] = useState([])
    const [formDatas, setFormDatas] = useState([])
    const [changeDealMargin, setChangeDealMargin] = useState()
    const [changeDealMargin2, setChangeDealMargin2] = useState()
    const [servicesData, setServiceData] = useState([])
    const [Popup, setPopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [popupData, setPopupData] = useState()
    const [displayDataToDeal, setDisplayDataToDeal] = useState()
    const [totalSumValues, setTotalSumValues] = useState({
        dealValue: 0,
        grossdealValue: 0,
        forecastedValue: 0,
        dealprofit: 0
    })
    const ConvertRates = currencySettings?.exchangeRate;
    const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    const isFormDataValid = formDatas.every(formData => {
        return requiredFields.every(field => {
            const value = formData[field];
            return value !== undefined && value !== '';
        });
    });
    const isservicesDataValid = servicesData.every(formData => {
        return Object.values(formData).every(value => value !== undefined && value !== '');
    });
    // const isroleDataValid = roleData.every(formData => {
    //     return Object.values(formData).every(value => value !== undefined && value !== '');
    // });
    function totalCalculation() {
        const dealValues = displayDataToDeal?.gross_deal_value || 0
        let sum = 0;
        let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        if (displayDataToDeal?.subtype === "Product and Services" || displayDataToDeal?.subtype === "Request for Proposal" || displayDataToDeal?.subtype === "Others") {
            if (isFormDataValid || isservicesDataValid) {
                if (formDatas.length === 0 && servicesData.length === 0) {
                    sum = 1 * dealValues;
                }
                else {
                    if (formDatas.length > 0) {
                        for (let i = 0; i < formDatas.length; i += 1) {
                            if (formDatas[i].total !== undefined)
                                sum += 1 * formDatas[i].total;
                        }
                    }
                    else if (!isservicesDataValid) {
                        sum = 1 * dealValues;
                    }
                    if (servicesData.length > 0) {
                        for (let i = 0; i < servicesData.length; i += 1) {
                            if (servicesData[i].serviceLineCost !== undefined)
                                sum += 1 * servicesData[i].serviceLineCost;
                        }
                    }
                    else if (!isFormDataValid) {
                        sum = 1 * dealValues;
                    }
                }
            }
            else if (displayDataToDeal?.subtype === "Request for Proposal" || displayDataToDeal?.subtype === "Others") {
                sum = 1 * dealValues;
            }
        }
        if (displayDataToDeal?.subtype === "Staff Augmentation") {
            for (let i = 0; i < roleData.length; i += 1) {
                if (roleData[i].totalValue !== undefined)
                    sum += 1 * roleData[i].totalValue;
            }
        }
        if (displayDataToDeal?.discount_percentage !== "0" && displayDataToDeal?.discount_percentage !== 0 && displayDataToDeal?.discount_percentage !== "" && displayDataToDeal?.discount_percentage !== null && displayDataToDeal?.discount_percentage !== undefined) {
            totalsum = sum * (1 - Number(displayDataToDeal?.discount_percentage) / 100)
        }
        else {
            totalsum = sum
        }
        if (winProbability !== undefined && winProbability !== "") {
            if (totalSumValues?.dealValue) {
                const dValue = 1 * totalSumValues.dealValue;
                Fvalue = dValue * (1 * winProbability / 100)
            }
        }
        if (pipeLineField !== "Won") {
            if (changeDealMargin !== undefined && changeDealMargin !== "") {
                if (totalSumValues?.dealValue) {
                    const dValue = 1 * totalSumValues.dealValue;
                    profit = dValue * (1 * changeDealMargin / 100)
                }
            }
        }
        if (pipeLineField === "Won") {
            if (changeDealMargin2 !== undefined && changeDealMargin2 !== "") {
                if (totalSumValues?.dealValue) {
                    const dValue = 1 * totalSumValues.dealValue;
                    profit = dValue * (1 * changeDealMargin2 / 100)
                }
            }
        }
        setTotalSumValues({
            dealValue: totalsum?.toFixed(CurencyDecimalPlace), // .toLocaleString(),
            grossdealValue: sum?.toFixed(CurencyDecimalPlace),
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace), // .toLocaleString(),
            dealprofit: profit?.toFixed(CurencyDecimalPlace)
        })
    }
    async function totalCalculationSubmit(pipeline, windata) {
        const dealValues = displayDataToDeal?.gross_deal_value || 0
        let sum = 0;
        let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        if (displayDataToDeal?.subtype === "Product and Services" || displayDataToDeal?.subtype === "Request for Proposal" || displayDataToDeal?.subtype === "Others") {
            if (isFormDataValid || isservicesDataValid) {
                if (formDatas.length === 0 && servicesData.length === 0) {
                    sum = 1 * dealValues;
                }
                else {
                    if (formDatas.length > 0) {
                        for (let i = 0; i < formDatas.length; i += 1) {
                            if (formDatas[i].total !== undefined)
                                sum += 1 * formDatas[i].total;
                        }
                    }
                    else if (!isservicesDataValid) {
                        sum = 1 * dealValues;
                    }
                    if (servicesData.length > 0) {
                        for (let i = 0; i < servicesData.length; i += 1) {
                            if (servicesData[i].serviceLineCost !== undefined)
                                sum += 1 * servicesData[i].serviceLineCost;
                        }
                    }
                    else if (!isFormDataValid) {
                        sum = 1 * dealValues;
                    }
                }
            }
            else if (displayDataToDeal?.subtype === "Request for Proposal" || displayDataToDeal?.subtype === "Others") {
                sum = 1 * dealValues;
            }
        }
        if (displayDataToDeal?.subtype === "Staff Augmentation") {
            for (let i = 0; i < roleData.length; i += 1) {
                if (roleData[i].totalValue !== undefined)
                    sum += 1 * roleData[i].totalValue;
            }
        }
        if (displayDataToDeal?.discount_percentage !== "0" && displayDataToDeal?.discount_percentage !== 0 && displayDataToDeal?.discount_percentage !== "" && displayDataToDeal?.discount_percentage !== null && displayDataToDeal?.discount_percentage !== undefined) {
            totalsum = sum * (1 - Number(displayDataToDeal?.discount_percentage) / 100)
        }
        else {
            totalsum = sum
        }
        if (windata !== undefined && windata !== "") {
            if (totalSumValues?.dealValue) {
                const dValue = 1 * totalSumValues.dealValue;
                Fvalue = dValue * (1 * windata / 100)
            }
        }
        if (pipeline !== "Won") {
            if (changeDealMargin !== undefined && changeDealMargin !== "") {
                if (totalSumValues?.dealValue) {
                    const dValue = 1 * totalSumValues.dealValue;
                    profit = dValue * (1 * changeDealMargin / 100)
                }
            }
        }
        if (pipeline === "Won") {
            if (changeDealMargin2 !== undefined && changeDealMargin2 !== "") {
                if (totalSumValues?.dealValue) {
                    const dValue = 1 * totalSumValues.dealValue;
                    profit = dValue * (1 * changeDealMargin2 / 100)
                }
            }
        }
        return {
            dealValue: totalsum?.toFixed(CurencyDecimalPlace),
            grossdealValue: sum?.toFixed(CurencyDecimalPlace),
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace),
            dealprofit: profit?.toFixed(CurencyDecimalPlace)
        }
    }
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    // const getChangedFields = (newData, oldData) => {
    //     return Object.keys(newData).reduce((acc, key) => {
    //         if (Array.isArray(newData[key]) && Array.isArray(oldData[key])) {
    //             if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
    //                 acc[key] = newData[key];
    //             }
    //         } else if (newData[key] !== oldData[key]) {
    //             acc[key] = newData[key];
    //         }
    //         return acc;
    //     }, {});
    // };
    const mapApiResponseToFormValues = (value) => {
        return value.products.map((product) => ({
            addProductId: product.add_product_id,
            // adjustmentType: product.adjustment_type,
            productCategory: product.product_category,
            dealProductId: product.deal_product_id,
            productLicenseSellingPriceUnitMonth: product.product_license_selling_price_unitMonth,
            numberOfUnits: product.number_of_units,
            licenseDuration: product.license_duration,
            // subtotal: product.subtotal,
            // adjustments: product.adjustments,
            total: product.total
        }));
    };
    const mapApiResponseToServicesValues = (value) => {
        return value.service.map((service) => ({
            serviceId: service.service_id,
            serviceName: service.service_name,
            serviceLineId: service.service_line_id,
            serviceLineCost: service.service_line_cost,
        }));
    };
    const mapApiResponseToRoleValues = (value) => {
        return value.staffRoles.map((role) => ({
            staffRoleId: role.staff_role_id,
            addStaffRoleId: role.add_staff_role_id,
            roleName: role.roleName,
            country: role.country,
            rolePerDayRate: role.role_per_day_rate,
            startDate: role.start_date,
            endDate: role.end_date,
            totalValue: role.total_value,
        }));
    };
    async function setInitialData(value) {
        const formValues = mapApiResponseToFormValues(value);
        const servicesValues = mapApiResponseToServicesValues(value);
        const roleValues = mapApiResponseToRoleValues(value)
        setDealInitial({
            pipelineStage: normalizeValue(value.pipeline_stage),
            dealProfit: normalizeValue(value.deal_profit),
            oldPipelineStage: normalizeValue(value.old_pipeline_stage),
            dealValue: normalizeValue(value.deal_value),
            expectedDealLength: normalizeValue(value.expected_deal_length),
            subtype: normalizeValue(value.subtype),
            discountPercentage: normalizeValue(value.discount_percentage),
            winProbability: normalizeValue(value.win_probability),
            forecastedValue: normalizeValue(value.forecasted_value),
            grossDealValue: normalizeValue(value.gross_deal_value),
            dealWonReason: normalizeValue(value.deal_won_reason),
            actualCloserDate: normalizeValue(value.actual_closer_date),
            actualDealMargin: normalizeValue(value.actual_deal_margin),
            dealLostReason: normalizeValue(value.deal_lost_reason),
            dealLostDate: normalizeValue(value.deal_lost_date),
            dealHoldReason: normalizeValue(value.deal_hold_reason),
            dealHoldDate: normalizeValue(value.deal_hold_date),
            dealRestartDate: normalizeValue(value.deal_restart_date),
            parentDealId: normalizeValue(value.parent_deal_id),
            staffRole: roleValues,
            products: formValues,
            services: servicesValues,
        })
    }
    async function setInitialData2(value) {
        setDealInitial2({
            pipelineStage: normalizeValue(value.pipeline_stage),
            oldPipelineStage: normalizeValue(value.old_pipeline_stage),
            dealValue: normalizeValue(value.deal_value),
            winProbability: normalizeValue(value.win_probability),
            forecastedValue: normalizeValue(value.forecasted_value),
            grossDealValue: normalizeValue(value.gross_deal_value),
            dealProfit: normalizeValue(value.deal_profit),
            commitStatus: normalizeValue(value.commit_status),
            parentDealId: normalizeValue(value.parent_deal_id),
            dealWonReason: null,
            actualCloserDate: null,
            actualDealMargin: null,
            dealLostReason: null,
            dealLostDate: null,
            dealHoldReason: null,
            dealHoldDate: null,
            dealRestartDate: null,
        })
    }
    const getRecuiredFields = async (dealId, pipleLineName) => {
        let drag = {
            success: false,
            pipelineId: null,
            dealType: "",
            statusss: null,
        };
        const dealresponse = await FetchDealDetails(dealId);
        const response = dealresponse.data
        const isNotEmpty = (value) => value !== "" && value !== undefined && value !== null;
        if (pipleLineName !== "Prospecting") {
            if (response.deal_type_name !== "Empanelment") {
                const allRequiredFieldsPresent =
                    [
                        response.subtype,
                        response.contact_person,
                        response.expected_closure_date,
                        response.win_probability,
                        response.deal_value,
                        response.revenue_start_date,
                        response.revenue_end_date,
                    ].every(isNotEmpty) &&
                    (response.deal_type_name !== "Expansion" || isNotEmpty(response.parent_deal_id));
                const isCommitRequired = (pipleLineName === "Negotiation" || pipleLineName === "Won");
                // const isCommitValid = !isCommitRequired || isNotEmpty(response.commit_status);
                // if (allRequiredFieldsPresent && isCommitValid) {
                if (allRequiredFieldsPresent) {
                    let statusss;
                    if (isCommitRequired) {
                        if (!isNotEmpty(response.commit_status)) {
                            statusss = "Soft Commit"
                        }
                        else {
                            statusss = response.commit_status
                        }
                    } else {
                        statusss = response.commit_status
                    }
                    drag = {
                        success: true,
                        pipelineId: response.pipeline_stage,
                        dealType: response.deal_type_name,
                        commitStatus: statusss
                    };
                } else {
                    drag = {
                        success: false,
                        pipelineId: response.pipeline_stage,
                        dealType: response.deal_type_name,
                    };
                }
            }
            else {
                const expectClosureDate = response.expected_closure_date;
                const isCommitRequired = (pipleLineName === "Negotiation" || pipleLineName === "Won");
                // const isCommitValid = !isCommitRequired || isNotEmpty(response.commit_status);
                // if (isNotEmpty(expectClosureDate) && isCommitValid) {
                if (isNotEmpty(expectClosureDate)) {
                    let statusss;
                    if (isCommitRequired) {
                        if (!isNotEmpty(response.commit_status)) {
                            statusss = "Soft Commit"
                        }
                        else {
                            statusss = response.commit_status
                        }
                    } else {
                        statusss = response.commit_status
                    }
                    drag = {
                        success: true,
                        pipelineId: response.pipeline_stage,
                        dealType: response.deal_type_name,
                        commitStatus: statusss
                    };
                }
                else
                    drag = {
                        success: false,
                        pipelineId: response.pipeline_stage,
                        dealType: response.deal_type_name,
                    };
            }
        }
        else {
            const isExpansionValid =
                response.deal_type_name !== "Expansion" || isNotEmpty(response.parent_deal_id);

            drag = {
                success: isExpansionValid,
                pipelineId: response.pipeline_stage,
                dealType: response.deal_type_name,
                commitStatus: response.commit_status
            };
        }
        return drag;
    }
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const handlePipeLineChange = async (value, option, winData, type) => {
        setCurrent(value)
        setPipeLineField(option)
        if (type === "Setting") {
            setWinProbability(winData)
        }
        else {
            setTrigger("")
            setNaCTrigger("trigger")
        }
        if (option === "on-Hold" || option === "On-Hold" || option === "Lost") {
            setOldPipeline(OldFixed)
        }
        else {
            setOldPipeline(null)
        }
        // if (option === "Won") {
        //     setWinProbability("100")
        // } else {
        //     // eslint-disable-next-line no-lonely-if
        //     if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {

        //     }
        // }
        if (type !== "Setting") {
            setDisabled(true)
            const process = await getRecuiredFields(UrlId[1], option)
            const Subcamcualtion = await totalCalculationSubmit(option, option === "Won" ? "100" : option === "Lost" ? "0" : winData)
            let hideMessage;
            if (process.success) {
                const DealValue = Subcamcualtion.dealValue
                    ? await convertCurrency(ConvertRates, Number(Subcamcualtion.dealValue))
                    : Subcamcualtion.dealValue;
                const DealProfit = Subcamcualtion.dealprofit
                    ? await convertCurrency(ConvertRates, Number(Subcamcualtion.dealprofit))
                    : Subcamcualtion.dealprofit;
                const GrossDealValue = Subcamcualtion.grossdealValue
                    ? await convertCurrency(ConvertRates, Number(Subcamcualtion.grossdealValue))
                    : Subcamcualtion.grossdealValue;
                const ForecastedValue = Subcamcualtion.forecastedValue
                    ? await convertCurrency(ConvertRates, Number(Subcamcualtion.forecastedValue))
                    : Subcamcualtion.forecastedValue;
                const convertedServicesData = await Promise.all(
                    servicesData.map(async (service) => {
                        const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                            convertCurrency(ConvertRates, Number(service.serviceLineCost))
                            : service.serviceLineCost
                        );
                        return {
                            ...service,
                            serviceLineCost: convertedCost.toString(),
                        };
                    })
                );
                const convertedRoleData = await Promise.all(
                    roleData.map(async (role) => {
                        const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                            ? convertCurrency(ConvertRates, Number(role.rolePerDayRate))
                            : role.rolePerDayRate);
                        const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== "" ?
                            convertCurrency(ConvertRates, Number(role.totalValue))
                            : role.totalValue);
                        return {
                            ...role,
                            rolePerDayRate: convertedRate.toString(),
                            totalValue: convertedTotalValue.toString(),
                        };
                    })
                );
                const convertedFormDatas = await Promise.all(
                    formDatas.map(async (product) => {
                        const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                            ? convertCurrency(ConvertRates, Number(product.productLicenseSellingPriceUnitMonth))
                            : product.productLicenseSellingPriceUnitMonth);
                        const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                            ? convertCurrency(ConvertRates, Number(product.total))
                            : product.total);
                        return {
                            ...product,
                            productLicenseSellingPriceUnitMonth: convertedPrice.toString(),
                            total: convertedTotal.toString(),
                        };
                    })
                );
                const formData = {
                    commitStatus:
                        (option !== "Prospecting" && option !== "Qualification" && option !== "Discovery")
                            ? normalizeValue(process.commitStatus) : null,
                    parentDealId: normalizeValue(displayDataToDeal?.deal_type_name === "Expansion" ? displayDataToDeal?.parent_deal_id : null),
                    subtype: normalizeValue(displayDataToDeal.subtype),
                    discountPercentage: normalizeValue(displayDataToDeal.discount_percentage),
                    expectedDealLength: normalizeValue(changeDealMargin),
                    dealProfit: normalizeValue(DealProfit?.toString()),
                    pipelineStage: normalizeValue(value),
                    actualDealMargin: normalizeValue(option === "Won" ? (changeDealMargin2 && changeDealMargin2 !== "") ? Number(changeDealMargin2) : changeDealMargin : null),
                    oldPipelineStage: normalizeValue((option === "on-Hold" || option === "On-Hold" || option === "Lost") ? oldPipeline : null),
                    dealValue: normalizeValue(DealValue?.toString()),
                    winProbability: normalizeValue(option === "Won" ? "100" : option === "Lost" ? "0" : winData),
                    forecastedValue: normalizeValue(ForecastedValue?.toString()),
                    grossDealValue: normalizeValue(GrossDealValue?.toString()),

                }
                if (displayDataToDeal?.subtype === "Staff Augmentation") {
                    formData.staffRole = convertedRoleData;
                    formData.products = [];
                    formData.services = [];
                } else if (displayDataToDeal?.subtype === "Product and Services" || displayDataToDeal?.subtype === "Request for Proposal") {
                    formData.products = convertedFormDatas;
                    formData.services = convertedServicesData;
                    formData.staffRole = [];
                } else {
                    formData.staffRole = [];
                    formData.products = [];
                    formData.services = [];
                }
                if (option !== "Won" && option !== "Lost" && (option !== "on-Hold" && option !== "On-Hold")) {
                    hideMessage = message.loading("Loading...", 0);
                    const payload = {
                        parentDealId: normalizeValue(displayDataToDeal?.deal_type_name === "Expansion" ? displayDataToDeal?.parent_deal_id : null),
                        pipelineStage: normalizeValue(value),
                        oldPipelineStage: normalizeValue((option === "on-Hold" || option === "On-Hold" || option === "Lost") ? oldPipeline : null),
                        dealValue: normalizeValue(DealValue?.toString()),
                        winProbability: normalizeValue(option === "Won" ? "100" : option === "Lost" ? "0" : winData),
                        forecastedValue: normalizeValue(ForecastedValue?.toString()),
                        grossDealValue: normalizeValue(GrossDealValue?.toString()),
                        dealProfit: normalizeValue(DealProfit?.toString()),
                        commitStatus:
                            (option !== "Prospecting" && option !== "Qualification" && option !== "Discovery")
                                ? normalizeValue(process.commitStatus) : null,
                        dealWonReason: null,
                        actualCloserDate: null,
                        actualDealMargin: null,
                        dealLostReason: null,
                        dealLostDate: null,
                        dealHoldReason: null,
                        dealHoldDate: null,
                        dealRestartDate: null,
                    }
                    const updatedFields = getChangedFields(payload, dealInitial2);
                    try {
                        const response = await DealUpdate(updatedFields, UrlId[1])
                        if (response.status === 200) {
                            hideMessage();
                            if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                                setErrorData(response.data);
                                setIsModalVisible1(true);
                            }
                            else {
                                // eslint-disable-next-line no-lonely-if
                                if (response.data[0].message === AutomationMessage) {
                                    if (option === "Won") {
                                        dispatch(setExPoCall(true));
                                        successMessage("Automation rule triggered", response.data[0].message)
                                        setTimeout(() => {
                                            dispatch(setExPoCall(false));
                                        }, 3000);
                                    } else {
                                        successMessage("Automation rule triggered", response.data[0].message)
                                    }
                                }
                                else if (response.data[0].message === ApprovalMessage) {
                                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                                }
                                else if (response.data[0].message !== ApprovalMessage && response.data[0].message !== AutomationMessage) {
                                    if (option === "Won") {
                                        dispatch(setExPoCall(true));
                                        successMessage("Proposal Won", "Proposal Closed! Congratulations on winning the deal! Time to celebrate your success")
                                        setTimeout(() => {
                                            dispatch(setExPoCall(false));
                                        }, 3000);
                                    } else {
                                        message.success("Proposal pipeline updated successful");
                                    }
                                } else {
                                    message.success("Proposal pipeline updated successful");
                                }
                            }
                            setNaCTrigger("CallBack")
                            setTrigger("activity")
                            getDetailsData()
                            setDisabled(false)
                        }
                    } catch (error) {
                        hideMessage();
                        getDetailsData()
                        message.error(error)
                        setDisabled(false)
                    }
                }
                else {
                    setPopup(true)
                    setDisabled(false)
                    setPopupData(formData)
                    setPopupType("Update")
                }
            }
            else {
                setDisabled(false)
                getDetailsData()
                setMessagePopup(true)
            }
        }
    }
    async function setDealCalculation(params) {
        const formValues = mapApiResponseToFormValues(params);
        const servicesValues = mapApiResponseToServicesValues(params);
        const roleValues = mapApiResponseToRoleValues(params)
        const DealValue = params.deal_value ? await ExchangeCurrency(Number(params.deal_value), ConvertRates) : params.deal_value;
        const ProfitDealValue = params.deal_profit && params.deal_profit !== "" ? await ExchangeCurrency(Number(params.deal_profit), ConvertRates) : params.deal_profit;
        const GrossDealValue = params.gross_deal_value ? await ExchangeCurrency(Number(params.gross_deal_value), ConvertRates) : params.gross_deal_value;
        const ForecastedValue = params.forecasted_value ? await ExchangeCurrency(Number(params.forecasted_value), ConvertRates) : params.forecasted_value;
        const convertedServicesData = await Promise.all(
            servicesValues.map(async (service) => {
                const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                    ExchangeCurrency(Number(service.serviceLineCost), ConvertRates)
                    : service.serviceLineCost
                );
                return {
                    ...service,
                    serviceLineCost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                };
            })
        );
        const convertedFormDatas = await Promise.all(
            formValues.map(async (product) => {
                const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                    ? ExchangeCurrency(Number(product.productLicenseSellingPriceUnitMonth), ConvertRates)
                    : product.productLicenseSellingPriceUnitMonth);
                // const convertedSubtotal = await (product.subtotal !== undefined && product.subtotal !== '' && product.subtotal !== null
                //     ? ExchangeCurrency(Number(product.subtotal), ConvertRates)
                //     : product.subtotal);
                const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                    ? ExchangeCurrency(Number(product.total), ConvertRates)
                    : product.total)
                return {
                    ...product,
                    productLicenseSellingPriceUnitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                    total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                };
            })
        );
        const convertedRoleData = await Promise.all(
            roleValues.map(async (role) => {
                const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                    ? ExchangeCurrency(Number(role.rolePerDayRate), ConvertRates)
                    : role.rolePerDayRate);
                const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== ""
                    ? ExchangeCurrency(Number(role.totalValue), ConvertRates)
                    : role.totalValue);
                return {
                    ...role,
                    rolePerDayRate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                    totalValue: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                };
            })
        );
        setRoleData(convertedRoleData)
        setServiceData(convertedServicesData)
        setFormDatas(convertedFormDatas)
        const updatedPerson = {
            ...params,
            gross_deal_value: Number(GrossDealValue?.toFixed(CurencyDecimalPlace)),
            deal_profit: Number(ProfitDealValue?.toFixed(CurencyDecimalPlace)),
            deal_value: Number(DealValue?.toFixed(CurencyDecimalPlace)),
            forecasted_value: Number(ForecastedValue?.toFixed(CurencyDecimalPlace)),
        };
        setDisplayDataToDeal(updatedPerson)
        if (updatedPerson?.pipeline_stage === 6 || updatedPerson?.pipeline_stage === 8) {
            if (Role !== "Administrator") {
                setMakeEdit(true)
            }
            else {
                setMakeEdit(false)
            }
        } else {
            setMakeEdit(false)
        }
        setChangeDealMargin(params.expected_deal_length)
        setChangeDealMargin2(params.actual_deal_margin !== undefined && params.actual_deal_margin !== null && params.actual_deal_margin !== "" ? params.actual_deal_margin : params.expected_deal_length)
        setInitialData(params)
        setInitialData2(params)
        // setWinProbability(params.win_probability)
        handlePipeLineChange(params.pipeline_stage, params.pipelineStage, params.win_probability, "Setting")
        if ((params.pipelineStage !== "on-Hold" && params.pipelineStage !== "On-Hold") && params.pipelineStage !== "Lost") {
            setOldPipeline(params.pipeline_stage)
            setOldFixed(params.pipeline_stage)
        }
        else {
            setOldPipeline(params.old_pipeline_stage)
            setOldFixed(params.old_pipeline_stage)
        }
    }
    useEffect(() => {
        if (displayData && displayData !== "Create") {
            setCurrent()
            setDealCalculation(displayData)
        }
    }, [displayData])
    useEffect(() => {
        if (displayDataToDeal) {
            totalCalculation()
        }
    }, [winProbability, displayDataToDeal, changeDealMargin, changeDealMargin2, totalSumValues?.dealValue])
    const getDetailsDataFunction = () => {
        setNaCTrigger("CallBack")
        setTrigger("activity")
        getDetailsData()
    }
    return (
        <>
            <div>
                <div style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    marginBottom: "15px",
                    display: "flex", alignItems: "center", gap: 5
                }}>
                    Proposal Pipeline Stage  {displayDataToDeal?.pipelineStage ? (
                        <div className={`table_list_clicks status-text PipeLine${(displayDataToDeal?.pipelineStage === "Prospecting" || displayDataToDeal?.pipelineStage === "Qualification" ) ? "NotQualified" : "Qualified"}`} style={{ fontSize: 10 }}>
                            {(displayDataToDeal?.pipelineStage === "Prospecting" || displayDataToDeal?.pipelineStage === "Qualification" ) ? <span style={{ display: "flex", alignItems: "center", gap: 5 }}> <FeatherIcon size={16} icon="x" />Not Qualified</span> :
                                <span style={{ display: "flex", alignItems: "center", gap: 5 }}> <FeatherIcon size={16} icon="check" />Qualified</span>}</div >
                    ) : null}
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "5px", fontSize: 12 }}>
                    <div>
                        Proposal Start Date: {displayDataToDeal?.created_at}
                    </div>
                    <div>
                        Expected Closure Date: {displayDataToDeal?.expected_closure_date ? moment(displayDataToDeal?.expected_closure_date).format(profile?.dateFormate ? profile?.dateFormate : "YYYY-MM-DD") : ""}
                    </div>
                </div>
                <ArrowPipeline
                    stages={stages}
                    currentStage={current}
                    onStageClick={(index, name) => handlePipeLineChange(index, name, winProbability, "Changeing")}
                    completedColor="#007bff"
                    upcomingColor="#e0e0e0"
                    textColor="#fff"
                    arrowHeight={40}
                    notchSize={6}
                    disabledItem={disabled}
                    displayData={displayDataToDeal}
                    oldPipeline={oldPipeline}
                    pipeLineStage={leadStatusData}
                    UpdatePs={UpdatePs}
                    canUpdateDelete={canUpdateDelete}
                    makeEdit={makeEdit}
                />
                <div style={{
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 15
                }}>
                    {extraStages.map((item) => {
                        const isCurrent = item.pipelineStageId === current;
                        const canEdit = canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId);
                        const isApprovedNone = displayData?.approved_for === "None";
                        const isInteractive = !isCurrent && canEdit && isApprovedNone && !makeEdit && !disabled;

                        return (
                            <div
                                key={item.pipelineStageId}
                                className={
                                    isCurrent
                                        ? "status-upadte-arrow-selected"
                                        : !canEdit
                                            ? "status-upadte-arrow2"
                                            : isApprovedNone
                                                ? "status-upadte-arrow"
                                                : "status-upadte-arrow2"
                                }
                                role="button"
                                tabIndex={0}
                                style={{
                                    cursor: isInteractive ? "pointer" : "default",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                onClick={() => {
                                    if (isInteractive) {
                                        handlePipeLineChange(item.pipelineStageId, item.pipelineStageName, winProbability, "Changeing");
                                    }
                                }}
                                onKeyDown={(event) => {
                                    if (
                                        isInteractive &&
                                        (event.key === 'Enter' || event.key === ' ')
                                    ) {
                                        handlePipeLineChange(item.pipelineStageId, item.pipelineStageName, winProbability, "Changeing");
                                    }
                                }}
                            >
                                {item.pipelineStageId === 7 ? (
                                    <OnHlodIcon marginRight={5} width={10} height={15} />
                                ) : (
                                    <LostIcon marginRight={5} width={13} height={15} />
                                )}
                                {item.pipelineStageName}
                            </div>
                        );
                    })}

                </div>
            </div>
            {Popup && <DealcreatePopup Popup={Popup} setPopup={setPopup}
                GetCallback={getDetailsDataFunction}
                popupType={popupType}
                Id={UrlId[1]}
                old={(pipeLineField === "on-Hold" || pipeLineField === "On-Hold" || pipeLineField === "Lost") ? oldPipeline : null}
                pipelineId={current}
                pipeline={pipeLineField}
                dealTypes={displayDataToDeal?.deal_type_name}
                dealDataSet={popupData}
                dealInitialDataset={dealInitial}
                currencyDataObject={currencySettings}
                successMessage={successMessage}
                AutomationMessage={AutomationMessage} setErrorData={setErrorData} setIsModalVisible1={setIsModalVisible1}
                ApprovalMessage={ApprovalMessage}
            />}
            {messagePopup && <DefaultPopup messagePopup={messagePopup} setMessagePopup={setMessagePopup} />}
        </>
    );
};

DealStageDemo.propTypes = {
    UrlId: PropTypes.array.isRequired,
    getDetailsData: PropTypes.func.isRequired,
    leadStatusData: PropTypes.array.isRequired,
    displayData: PropTypes.object.isRequired,
    currencySettings: PropTypes.object.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    UpdatePs: PropTypes.object.isRequired,
    canUpdateDelete: PropTypes.func.isRequired,
    ApprovalMessage: PropTypes.string.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
    setErrorData: PropTypes.func.isRequired,
    setIsModalVisible1: PropTypes.func.isRequired,
    setTrigger: PropTypes.func.isRequired,
};

export default DealStageDemo;

